// extracted by mini-css-extract-plugin
module.exports = {"content":"style-module__content___jpghs","list":"style-module__list___2hzoP"};